import React from 'react';
import styled from 'styled-components';
import { useBoardStore } from '../../../boardStore';

const TruckNumber = styled.div`
    overflow: hidden;
    display: inline-block;
    margin-left:-0.4rem;
    &>span{
        display: inline-block;
        overflow: hidden;
        // text-overflow: ellipsis;
        max-width: calc(100% - 0.4rem);
        &:first-child{
            font-weight:800;
            white-space: nowrap;
            cursor:pointer;
            color:var(--gray);
            border-radius:0.4rem;
            padding:0.4rem 0.6rem;
            
            ${props => props.$truckType ? 
                props.$truckType === "Owner" ? `
                background-color:rgba(var(--inProgressPurpleRGB), 0.3);
            `: props.$truckType === "outOfOrdinary" ? 
            `background-color:rgba(var(--inProgressBlueRGB), 0.3);
            `:`
                background-color:rgba(var(--inProgressYellowRGB), 0.4);
                
            `:`
            `}
        }
        
    }
    
`  
// &:not(:first-child){
//     font-size:0.8rem;
//     margin-left: 0.5rem;
//     position:absolute;
//     border-radius:0.4rem;
//     background-color:rgba(var(--successGreenRGB), 0.3);
//     color: rgb(var(--successGreenRGB));
//     font-weight:600;
//     padding:0.2rem;
// }
// <span>
// D
// </span>

export const MB_TRUCK_NUMBER = ({truckData, mainlySolo}) => {
    const openPopupTruck = useBoardStore(s => s.openPopupTruck);
    let truckType = null;
    if(mainlySolo && truckData.driver1 && truckData.driver2 ){
        truckType = "outOfOrdinary";
    }else if(!mainlySolo && (!truckData.driver1 || !truckData.driver2)){
        truckType = "outOfOrdinary";
    }
    return <TruckNumber 
    $truckType={truckData.truckType === "Company" ? truckType : truckData.truckType} 
    >
        <span 
        
        className="truckNumberHoldingContainer"
        onClick={
            ()=>{
                openPopupTruck(truckData.id);
            }}
        >
            {truckData.truckNumber}
        </span>
        
    </TruckNumber>
}
